import styled from 'styled-components'

import SizesMap, { Sizes } from './Margin.sizes'

interface MarginProps {
    bottom?: boolean
    inline?: boolean
    left?: boolean
    noMargin?: boolean
    right?: boolean
    size?: Sizes
    top?: boolean
    textTruncated?: boolean
}

const Margin = styled.div<MarginProps>`
    ${({ inline = false }) => inline && 'display: inline-block;'}

    ${({ size = Sizes.sm, top = false, bottom = false, left = false, right = false, noMargin = false }): string | undefined => {
        const { [size]: s } = SizesMap
        if (!s) {
            return
        }

        if (
            [bottom, top, left, right, noMargin].every((a) => !a) || // All to be false, or
            [bottom, top, left, right, noMargin].every((a) => a) // All to be true
        ) {
            return `margin: ${s}; `
        }

        let rules = ''
        if (bottom && !noMargin) {
            rules += `margin-bottom: ${s}; `
        }

        if (top && !noMargin) {
            rules += `margin-top: ${s}; `
        }

        if (left && !noMargin) {
            rules += `margin-left: ${s}; `
        }

        if (right && !noMargin) {
            rules += `margin-right: ${s}; `
        }

        return rules
    }}

    ${({ textTruncated = false }) => textTruncated && 'white-space: nowrap; overflow: hidden; text-overflow: ellipsis;'}
`

export default Margin
